import "./App.css"
import { TypefacePluginIFrame } from "@typeface-ai/typeface-embed-react/lib/esm/index"

import { TypefaceEmbedIDP, TypefaceEmbedUseCase } from "@typeface-ai/typeface-embed-react/lib/esm/model"
import { config } from "./utils"
import { SOURCE_APP } from "./constants"
import { useEffect } from "react"

function AssetPicker() {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== config.webApp) return

      console.log("Message from Typeface iframe:", event.data)

      window.parent.postMessage(
        {
          type: "tf-embed-event-proxy",
          payload: event.data,
        },
        "*",
      )
    }
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [])

  return (
    <>
      <TypefacePluginIFrame
        idp={TypefaceEmbedIDP.Typeface}
        sourceApp={SOURCE_APP}
        typefaceOrigin={`${config.webApp}`}
        useCase={TypefaceEmbedUseCase.DAMIntegration}
        styles={{ width: "100vw", height: "100vh", showAccountSwitcher: true }}
        onApply={function (): void {
          throw new Error("Function not implemented.")
        }}
        onCancel={function (): void {
          throw new Error("Function not implemented.")
        }}
      />
    </>
  )
}

export default AssetPicker
